import { Card, ConfigProvider, Flex, Typography } from 'antd';
import Icon from '@ant-design/icons';
import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as SOSTicket } from '../../../../assets/icons/sos-ticket-white.svg';
import { ReactComponent as SOSTicketBlack } from '../../../../assets/icons/sos-ticket-black.svg';
import { ReactComponent as RashDrivingAnomaly } from '../../../../assets/icons/rash-driving-anomaly-white.svg';
import { ReactComponent as RashDrivingAnomalyBlack } from '../../../../assets/icons/rash-driving-anomaly-black.svg';
import { ReactComponent as DriverDrowsiness } from '../../../../assets/icons/driver-drowsiness-white.svg';
import { ReactComponent as DriverDrowsinessBlack } from '../../../../assets/icons/driver-drowsiness-black.svg';
import { ReactComponent as DriverDistraction } from '../../../../assets/icons/driver-distraction-anomaly-white.svg';
import { ReactComponent as DriverDistractionBlack } from '../../../../assets/icons/driver-distraction-anomaly-black.svg';
import { ReactComponent as OverSpeed } from '../../../../assets/icons/overspeed-white.svg';
import { ReactComponent as OverSpeedBlack } from '../../../../assets/icons/overspeed-black.svg';
import { ReactComponent as DoorOpen } from '../../../../assets/icons/door-open-white.svg';
import { ReactComponent as DoorOpenBlack } from '../../../../assets/icons/door-open-black.svg';
import { useTheme } from '../../../../context/ThemeContext';
import { DARK, DMS_TYPE } from '../../../../utilities/constants';

const { Text } = Typography;

const getCardIcon = (iconKey, theme) => {
  switch (iconKey) {
    case 'sos':
      return theme === DARK ? SOSTicket : SOSTicketBlack;
    case 'rash_driving':
      return theme === DARK ? RashDrivingAnomaly : RashDrivingAnomalyBlack;
    case DMS_TYPE.DROWSINESS:
      return theme === DARK ? DriverDrowsiness : DriverDrowsinessBlack;
    case DMS_TYPE.DISTRACTION:
      return theme === DARK ? DriverDistraction : DriverDistractionBlack;
    case 'door_open':
      return theme === DARK ? DoorOpen : DoorOpenBlack;
    case 'overspeed':
      return theme === DARK ? OverSpeed : OverSpeedBlack;
    default:
      return null;
  }
};

const CardTitle = ({ title, time, icon, iconKey }) => {
  const { theme } = useTheme();
  const resolvedIcon = iconKey ? getCardIcon(iconKey, theme) : icon;

  return (
    <Flex justify="space-between" align="center" gap={8} wrap="wrap">
      <Flex align="center" gap={8}>
        {resolvedIcon && <Icon component={resolvedIcon} />}
        <Text
          strong
          style={{
            fontWeight: 700,
          }}
        >
          {title}
        </Text>
      </Flex>
      <Text style={{ fontSize: '0.875rem' }}>{time}</Text>
    </Flex>
  );
};

CardTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  time: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  iconKey: PropTypes.string,
};

const SafetyAnomalyCard = ({ titleContent, children }) => {
  const { theme } = useTheme();
  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            headerBg: theme === DARK ? '#2E3033' : '#FFFFFF',
            colorBgContainer: theme === DARK ? '#1A1C1D' : '#EFF1F2',
            colorBorderSecondary: theme === DARK ? '#2E3033' : '#E0E2E5',
          },
        },
      }}
    >
      <Card
        className="safety-anomaly-card"
        title={
          <CardTitle
            title={titleContent?.title}
            icon={titleContent?.icon}
            iconKey={titleContent?.iconKey}
            time={titleContent?.time}
          />
        }
        size="small"
      >
        {children}
      </Card>
    </ConfigProvider>
  );
};

SafetyAnomalyCard.propTypes = {
  titleContent: PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    time: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    iconKey: PropTypes.string,
  }),
  children: PropTypes.node,
};

export default React.memo(SafetyAnomalyCard);
